<script setup lang="ts">
  import Typography from '@/components/common/Typography.vue'
  import HandPointRibbonIcon from '@/components/icons/HandPointRibbonIcon.vue'
  import LightBulbIcon from '@/components/icons/LightBulbIcon.vue'
  import IbexaColorPair from '@/enums/IbexaColorPair'
  import RichTextRenderer from '@/components/common/RichTextRenderer.vue'

  defineProps<{
    title: string
    text: string
    icon: 'Husk' | 'Tips'
    colorPair: keyof typeof IbexaColorPair
  }>()

  const getIcon = (icon?: 'Husk' | 'Tips') => {
    switch (icon) {
    case 'Husk':
    default:
      return HandPointRibbonIcon
    case 'Tips':
      return LightBulbIcon
    }
  }

</script>

<template>
  <div :class="IbexaColorPair[colorPair]" class="color-box">
    <div>
      <component :is="getIcon(icon)" />
    </div>
    <div>
      <Typography
        variant="h4"
        :font-weight="800"
      >
        {{ title }}
      </Typography>
      <RichTextRenderer :rich-text="text" />
    </div>
  </div>
</template>

<style scoped lang="scss">
  @include color-pairs;

  .color-box {
    display: flex;

    /* makes the padding fluid based on view port width */
    padding: clamp(2rem, 2vw + 1.25rem, 2.5rem) clamp(1rem, 2vw + .5rem, 2.5rem);
    color: var(--color-pair-color);
    background-color: var(--color-pair-background-color);

    div {
      display: block;
      margin-right: 16px;

      svg {
        transform: scaleX(-1);
        fill: var(--color-pair-color);

        /* makes the icon fluid based on view port width */
        width: clamp(2.5rem, 3.91vw + 1rem, 3.5rem);
        height: clamp(2.5rem, 3.91vw + 1rem, 3.5rem);
      }
    }
  }
</style>
